import React from 'react';
import TeamPageLayout from '../components/TeamPageLayout';
import TeamSettings from '../components/TeamSettings';

/**
 * Settings tab only: layout (with shared tabs) + settings view.
 * Receives common data from parent; contains no activity or connector logic.
 */
function TeamSettingsContainer({
  team = null,
  teamConnectorConfigurations = [],
  teamConnectorConfigurationsHasLoaded = false,
  onUpdateTeam = () => {},
  onAddTeamMember = () => {},
  onUpdateTeamMember = () => {},
  onRemoveTeamMember = () => {},
  connectors = [],
  connectorsHasLoaded = false,
  onSaveConnectorConfiguration = () => {},
  onDeleteConnectorConfiguration = () => {},
  onTestConnectorConfiguration = () => {},
}) {
  const handleUpdate = (values) =>
    onUpdateTeam(team ? { id: team.id, ...values } : values);

  return (
    <TeamPageLayout
      team={team}
      teamConnectorConfigurations={teamConnectorConfigurations}
      teamConnectorConfigurationsHasLoaded={
        teamConnectorConfigurationsHasLoaded
      }
    >
      <TeamSettings
        team={team}
        onUpdate={handleUpdate}
        onAddTeamMember={onAddTeamMember}
        onUpdateTeamMember={onUpdateTeamMember}
        onRemoveTeamMember={onRemoveTeamMember}
        connectors={connectors}
        teamConnectorConfigurations={teamConnectorConfigurations}
        connectorsHasLoaded={connectorsHasLoaded}
        teamConnectorConfigurationsHasLoaded={
          teamConnectorConfigurationsHasLoaded
        }
      />
    </TeamPageLayout>
  );
}

export default TeamSettingsContainer;
